import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { font, color } = baseVariables;

export const StyledMobileCalendar = styled.div<{ align?: string }>`
  background-color: ${color.base20};

  .DayPicker-tooltip-value {
    display: none;
  }

  .calendar-sticky-header {
    position: sticky;
    top: 0;
    background: ${color.base20};
    z-index: 10;
  }

  .calendar-message-container {
    display: flex;
    justify-content: center;
    margin-top: ${toRem(16)};
  }

  .calendar-badge {
    background-color: ${color.neutral20};
    color: ${color.base10};
    font-family: ${font.fontFamilySwiss};
    font-size: ${font.fontXs};
    padding: ${toRem(8)};
    border-radius: ${toRem(4)};
    margin: 0 auto;
    text-align: center;
    width: 100%;
  }

  .m-input-text-field {
    padding-bottom: ${toRem(16)};
    &.focus-input {
      input {
        border-color: ${color.base10};
        box-shadow: 0 0 0 ${toRem(0.5)} inset;
      }
    }

    .text-container {
      position: relative;
    }
  }

  .groups-tab-container {
    .container {
      box-shadow: none;
      padding: 0;
    }
  }

  .m-switcher-tab-list-item {
    font-weight: ${font.fontWeightMedium};
    &.active span {
      color: ${color.base10};
    }
  }
`;
